var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWornBrakeFailure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "50px",
    height: "50px",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{display:none;}\r\n\t.st1{display:inline;fill:#1A1A1A;}\r\n\t.st2{display:inline;}\r\n\t.st3{fill:#1A1A1A;}\r\n\t.st4{display:none;fill:#1A1A1A;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M24.06,5.91c-10.22,0-18.53,8.31-18.53,18.53c0,10.22,8.31,18.53,18.53,18.53s18.53-8.31,18.53-18.53 C42.59,14.22,34.27,5.91,24.06,5.91z M24.06,39.47c-8.29,0-15.03-6.74-15.03-15.03S15.77,9.4,24.06,9.4 c8.29,0,15.03,6.74,15.03,15.03S32.35,39.47,24.06,39.47z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.8,18.75l1.32,0.35c0.09,0.02,0.18,0.04,0.28,0.04c0.45,0,0.86-0.29,1.01-0.72 c0.78-2.24,1.96-4.29,3.52-6.08c0.37-0.42,0.35-1.06-0.05-1.45L7.9,9.93c-0.42-0.42-1.17-0.4-1.56,0.05 c-1.91,2.18-3.35,4.67-4.29,7.41c-0.09,0.28-0.07,0.58,0.07,0.84C2.27,18.48,2.51,18.68,2.8,18.75z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.64,29.54l1.32-0.35c0.54-0.14,0.87-0.69,0.77-1.23c-0.23-1.16-0.34-2.34-0.34-3.51 c0-1.17,0.11-2.35,0.34-3.51c0.11-0.55-0.23-1.09-0.77-1.23l-1.32-0.35c-0.58-0.16-1.21,0.23-1.32,0.82 c-0.28,1.41-0.43,2.85-0.43,4.28c0,1.43,0.14,2.87,0.43,4.28c0.1,0.5,0.54,0.85,1.05,0.85C2.46,29.57,2.55,29.56,2.64,29.54z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.4,30.45c-0.18-0.52-0.75-0.83-1.28-0.69l-1.33,0.35c-0.28,0.08-0.53,0.27-0.67,0.53 c-0.14,0.26-0.16,0.57-0.07,0.84c0.93,2.73,2.37,5.22,4.29,7.41c0.2,0.23,0.49,0.36,0.8,0.36c0,0,0,0,0,0 c0.29,0,0.56-0.11,0.76-0.31l0.97-0.97c0.39-0.39,0.41-1.03,0.05-1.45C7.35,34.73,6.17,32.68,5.4,30.45z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M45.32,30.12l-1.32-0.35c-0.53-0.14-1.1,0.17-1.28,0.68c-0.78,2.24-1.96,4.29-3.52,6.08 c-0.37,0.42-0.34,1.06,0.05,1.45l0.97,0.97c0.2,0.2,0.47,0.31,0.76,0.31c0,0,0,0,0,0c0.31,0,0.6-0.13,0.8-0.36 c1.91-2.18,3.35-4.67,4.29-7.41c0.09-0.28,0.07-0.58-0.07-0.84C45.84,30.39,45.6,30.19,45.32,30.12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M46.8,20.15c-0.12-0.59-0.74-0.98-1.32-0.82l-1.32,0.35c-0.54,0.14-0.87,0.69-0.77,1.23 c0.23,1.16,0.34,2.34,0.34,3.51c0,1.17-0.11,2.35-0.34,3.51c-0.11,0.55,0.23,1.09,0.77,1.23l1.32,0.35 c0.09,0.02,0.21,0.03,0.28,0.04c0.51,0,0.95-0.36,1.04-0.85c0.28-1.41,0.43-2.85,0.43-4.28C47.22,23.01,47.08,21.57,46.8,20.15z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M42.72,18.42c0.15,0.43,0.55,0.72,1.01,0.72c0.09,0,0.18-0.01,0.27-0.04l1.33-0.36 c0.29-0.08,0.53-0.27,0.67-0.53c0.14-0.26,0.16-0.57,0.07-0.84c-0.93-2.73-2.37-5.22-4.29-7.41c-0.39-0.44-1.14-0.46-1.55-0.05 l-0.97,0.97c-0.39,0.39-0.41,1.03-0.05,1.45C40.76,14.14,41.94,16.19,42.72,18.42z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWornBrakeFailure);
export default __webpack_public_path__ + "static/media/WornBrakeFailure.c5f74d9bcb32bc8e89441deb1f877005.svg";
export { ForwardRef as ReactComponent };